import { RouterProvider } from 'react-router-dom';
import { router } from 'router';
import { useKeycloak } from '@react-keycloak/web';
import { LoginScreen } from 'screens';
import { useState, useEffect } from 'react';

export default function App() {
  const { keycloak, initialized } = useKeycloak();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (initialized) {
      setIsAuthenticated(!!keycloak.authenticated);
    }
  }, [initialized, keycloak]);

  if (!initialized) {
    return <div>Loading App...</div>;
  }

  if (!isAuthenticated) {
    return <LoginScreen onLoginSuccess={() => setIsAuthenticated(true)} />;
  }

  return <RouterProvider router={router} />;
}